



































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import CurrentHoldingsChart from "@/shared/components/investments/drivewealth/CurrentHoldingsChart.vue";
import AdvisoryFunds from "@/shared/components/investments/drivewealth/AdvisoryFunds.vue";
import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import InvestWithDrivewealthWidget from "@/employee/components/investments/drivewealth/InvestWithDrivewealthWidget.vue";
import PreenrollmentWidget from "@/employee/components/investments/drivewealth/PreenrollmentWidget.vue";
import SweepCallToAction from "@/shared/components/investments/drivewealth/SweepCallToAction.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import UserPartnerContent from "@/employee/components/investments/drivewealth/UserPartnerContent.vue";
import PreenrollmentManagement from "@/shared/components/investments/drivewealth/PreenrollmentManagement.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { DrivewealthWizardStep } from "@/shared/types";
import * as Routes from "@/employee/route-names";

@Component({
  components: {
    DrivewealthNavigation,
    CurrentHoldingsTable,
    AdvisoryFunds,
    CurrentHoldingsChart,
    GenericLoadingSpinner,
    InvestWithDrivewealthWidget,
    SweepCallToAction,
    RiskDisclaimer,
    UserPartnerContent,
    PreenrollmentWidget,
    PreenrollmentManagement,
    AccountTypeSubheader
  }
})
export default class DrivewealthInvestmentPage extends Vue {
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  featureFlagStore = useFeatureFlagStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();

  finishedCheckingAccountClaims = false;

  @Prop() accountId: number;
  @Prop() force: boolean;

  @Watch("drivewealthWizardStore.isPreenrolled")
  load () {
    if (this.accountId) {
      this.drivewealthStore.getAccountV2({ username: null, partnerId: null, accountId: this.accountId, force: this.force });
    } else {
      this.drivewealthStore.loadDefaultAccount();
    }
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({ force: true });
    if (this.accountId) {
      this.drivewealthSweepStore.getSweepV2({});
    } else {
      this.drivewealthSweepStore.getSweep({});
    }
    this.drivewealthWizardStore.loadExistingPreenrollment({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthStore.loadAccountClaims({});
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      this.signingDocumentStore.getHsabDrivewealthAccountSignature();
    }
  }

  @Watch("accountId")
  reload () {
    this.load();
  }

  mounted () {
    this.load();
  }

  get showLoadingSpinner () {
    return !this.isLoaded && !this.finishedCheckingAccountClaims;
  }

  get isLoaded () {
    const isLoaded = this.drivewealthStore.drivewealthLoaded &&
      this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded &&
      this.drivewealthSweepStore.sweepLoaded &&
      this.drivewealthStore.isAccountClaimsLoaded;

    if (isLoaded) {
      this.redirectIfMissingAccountClaims();
    }
    return isLoaded;
  }

  get showPreenrollment () {
    // only shown in UI (via v-if) when: this.isLoaded && !this.hasAnAccount && !this.isPreenrolled
    return !this.investmentDailyBalanceStore.hasEnoughToOpenAccount &&
      this.drivewealthWizardStore.isAllowedToPreenroll &&
      this.featureFlagStore.flags.allowDrivewealthPreenrollment;
  }

  redirectIfMissingAccountClaims () {
    if (this.drivewealthStore.primaryAccount && this.drivewealthStore.isAccountClaimsLoaded) {
      const primaryAccountId = this.drivewealthStore.primaryAccount.accountId;
      const accountIdToUse = this.accountId === undefined ? primaryAccountId : this.accountId;
      const accountClaim = this.drivewealthStore.accountClaims.find(c => c.drivewealthApiAccountId === accountIdToUse);
      if (this.drivewealthStore.primaryAccount && accountClaim && accountClaim.isClaimed === false) {
        this.$router.replace({ name: Routes.DrivewealthInvestmentAccountClaims,
          params: { step: DrivewealthWizardStep.RequiredDisclosures} });
      }
      this.finishedCheckingAccountClaims = true;
    }
  }
}
